<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['userInfo'])
		},
		onLaunch: function() {
			var that = this;
			console.log(JSON.stringify(this.userInfo))
			if (JSON.stringify(this.userInfo) == '{}') {
				uni.login({
					provider: 'weixin',
					success: async function (loginRes) {
						let { code } = loginRes;
						let res = await that.$u.api.wxLogin({ code })
						if (res.code === 200) {
							that.$store.commit('setToken', res.data.token)
							that.$store.commit('setUserInfo', res.data.userResponse)
							that.$isResolve()
						}
					}
				});
			} else {
				that.$isResolve()
			}
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	@import "uview-ui/index.scss";
	@import "static/css/lib.css";
</style>